import { useEffect, useState } from "react";
import api from "../lib/api";
import MissionsTabs from "../components/MissionsTabs";
import { useTranslation } from "react-i18next";
import { Calendar, MapPin, Clock, Check, X, Building2 } from "lucide-react";

export default function MyMissions() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const load = async () => {
    const { data } = await api.get("/bookings");
    setRows(data);
  };
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    await api.post(`/bookings/${id}/action`, { action });
    load();
  };

  const pendingCount = rows.filter((r) => r.status === "pending").length;

  return (
    <div className="min-h-screen bg-[#F7F8F6] pb-24 lg:pb-0">
      <header className="bg-[#0F2A1B] text-white px-5 pt-10 pb-7 rounded-b-3xl">
        <div className="text-xs text-white/60 uppercase tracking-wider">Mes missions</div>
        <h1 className="text-2xl font-medium mt-1" style={{ fontFamily: "Outfit" }}>Propositions & missions</h1>
      </header>
      <main className="px-5 lg:max-w-3xl lg:mx-auto mt-4">
        <div className="mb-4">
          <MissionsTabs pendingCount={pendingCount} />
        </div>
        {rows.length === 0 ? (
          <div className="rp-card p-10 text-center text-sm text-[#6B726A]">Aucune mission proposée pour l'instant.</div>
        ) : (
          <div className="space-y-3">
            {rows.map((b) => (
              <div key={b.id} className="rp-card p-5" data-testid={`my-mission-${b.id}`}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <Building2 className="w-4 h-4 text-[#1A4D2E]" />
                    <span className="font-medium">{b.pharmacy_name}</span>
                  </div>
                  {b.need_snapshot?.urgent && <span className="text-xs bg-[#FFF4F3] text-[#E3655B] px-2 py-1 rounded-full font-medium">{t("needs.urgent")}</span>}
                </div>
                <div className="text-xs text-[#6B726A] mb-3">{b.need_snapshot?.role_type}</div>
                <div className="space-y-1 text-sm mb-3">
                  <div className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-[#6B726A]" />{b.need_snapshot?.start_date}</div>
                  <div className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-[#6B726A]" />{b.need_snapshot?.start_time} – {b.need_snapshot?.end_time}</div>
                  <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-[#6B726A]" />{b.need_snapshot?.address}</div>
                </div>
                {b.status === "pending" ? (
                  <div className="flex gap-2 pt-3 border-t border-[#E2E5E0]">
                    <button onClick={() => act(b.id, "accept")} data-testid={`accept-${b.id}`} className="flex-1 bg-[#1A4D2E] text-white rounded-full py-2.5 text-sm font-medium flex items-center justify-center gap-1.5 hover:bg-[#143C24]">
                      <Check className="w-4 h-4" /> {t("bookings.accept")}
                    </button>
                    <button onClick={() => act(b.id, "refuse")} data-testid={`refuse-${b.id}`} className="flex-1 bg-[#E3655B] text-white rounded-full py-2.5 text-sm font-medium flex items-center justify-center gap-1.5 hover:bg-[#cf564c]">
                      <X className="w-4 h-4" /> {t("bookings.refuse")}
                    </button>
                  </div>
                ) : (
                  <div className={`text-xs px-3 py-1.5 rounded-full font-medium inline-flex w-fit ${
                    b.status === "confirmed" ? "bg-[#E8F0EA] text-[#1A4D2E]" : "bg-[#F0F2EF] text-[#6B726A]"
                  }`}>
                    {b.status === "confirmed" ? t("bookings.confirmed") : t("bookings.refused")}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
